import { DiscoverVerticalEventCard } from '@eventbrite/consumer-search.discover-utils';
import { FormattedEvent } from '@eventbrite/consumer-search.event-renderer';
import { HEAP_LOCATION_STRING } from '@/constants/analytics';
import { useIsEventbritePlusEnabled } from '@/bsp/config';
import { useClientAuth } from '@/common/useUserPublicId';
import { useUserSubscription } from '@/common/useUserSubscription';
import styles from './EventCard.module.scss';
import { useAppContext } from '@/common/context';

interface Props {
    event: FormattedEvent;
    hidePriceDescription: boolean;
    bucketLabel: string;
    affCode: string;
    isAuthenticated: boolean;
    showSaveAction?: boolean;
    showShareAction?: boolean;
}

export const EventCard: React.FC<Props> = ({
    event,
    hidePriceDescription,
    bucketLabel,
    affCode,
    isAuthenticated,
    showSaveAction = false,
    showShareAction = false,
}) => {
    const { locale } = useAppContext();
    const { isEnabled: isEventbritePlusEnabled } = useIsEventbritePlusEnabled();
    const { publicUserId } = useClientAuth();
    const { hasEarlyAccessPurchaseWindows } = useUserSubscription(publicUserId);
    const showEarlyAccessLabel =
        isEventbritePlusEnabled &&
        hasEarlyAccessPurchaseWindows &&
        event.hasEarlyAccessTickets === true &&
        event.eventSalesStatus?.salesStatus === 'not_yet_on_sale';
    return (
        <div className={styles.feedCardCell}>
            <DiscoverVerticalEventCard
                locale={locale}
                showEarlyAccessLabel={showEarlyAccessLabel}
                statsigLocationString={HEAP_LOCATION_STRING}
                isAuthenticated={isAuthenticated}
                event={event}
                /* FIXME make isLazyImage dynamic for SSR and consider next/image */
                isLazyImage={false}
                hidePriceDescription={hidePriceDescription}
                affCode={affCode}
                data-testid={`home-event-card-${event.id}`}
                bucketLabel={bucketLabel}
                showSaveAction={showSaveAction}
                showShareAction={showShareAction}
                shareOptions={{
                    utmOptions: {
                        'utm-campaign': 'social',
                        'utm-content': 'attendeeshare',
                        'utm-medium': 'discovery',
                        'utm-term': 'listing',
                        'utm-source': 'cp',
                    },
                }}
            />
        </div>
    );
};
